/**
 * Events beginning with an underscore (_) are not tied to an element's ID
 * attribute, all other events are meant to be used in a data attribute for
 * the event tracker or manual retrieval
 */

const ORDER_TYPE_SALES = 'sales';
const ORDER_TYPE_EXCHANGE = 'exchange';
const ORDER_TYPE_SALES_SEARCH = 'sales_search';
const ORDER_TYPE_EXCHANGE_SEARCH = 'exchange_search';
const RMA_CATEGORY_NAME = 'RMA';
const CONSUMER_OM_CATEGORY_NAME = 'Consumer - OM';
const OM_LANDING_CATEGORY_NAME = 'OM Landing';
const PRODUCT_IDENTIFICATION_ACTION_NAME = 'Product Identification';
const PRODUCT_IDENTIFIED_ACTION_NAME = 'Product Identified - Name';

export default {
  noProductCustomDimension: 'No Product Flow',
  dataEventIdAttribute: 'data-event-id',
  rmaEventCategory: RMA_CATEGORY_NAME,
  orderManagementCategory: CONSUMER_OM_CATEGORY_NAME,
  orderLandingCategory: OM_LANDING_CATEGORY_NAME,

  productSelectionFlowToGACategoryName: {
    [ORDER_TYPE_SALES_SEARCH]: CONSUMER_OM_CATEGORY_NAME,
    [ORDER_TYPE_EXCHANGE_SEARCH]: RMA_CATEGORY_NAME,
    [ORDER_TYPE_SALES]: OM_LANDING_CATEGORY_NAME,
    [ORDER_TYPE_EXCHANGE]: RMA_CATEGORY_NAME,
  },

  productSelectionFlowToGAActions: {
    [ORDER_TYPE_SALES_SEARCH]: PRODUCT_IDENTIFICATION_ACTION_NAME,
    [ORDER_TYPE_EXCHANGE_SEARCH]: PRODUCT_IDENTIFICATION_ACTION_NAME,
    [ORDER_TYPE_SALES]: PRODUCT_IDENTIFIED_ACTION_NAME,
    [ORDER_TYPE_EXCHANGE]: PRODUCT_IDENTIFIED_ACTION_NAME,
  },
  analyticsEvents: {
    '_systems_search-query-form-submit': {
      category: '[System]-Search',
      action: 'Search',
      label: '[SearchTerm]',
    },
    'js__product-id-help-button': {
      category: 'Support Landing',
      action: 'How do I identify my product information',
      label: 'Internal Link',
    },
    'js__sp-topics-tab-button': {
      category: 'Product - Welcome',
      page_type: 'Product - Welcome',
      action: 'Link',
      link_type: 'Link',
      label: 'View All Product Content',
    },
    'js__search__no-product__cta': {
      category: 'Support Landing',
      action: 'My question is not about a product',
      label: 'Internal Link',
    },
    'js__sp__change-topic': {
      category: 'Support Search Result',
      action: 'Update Search',
      label: 'Click',
    },
    'js__sp-more-video-results': {
      category: '[Category]',
      label: 'Show More Videos',
      action: 'Link',
    },
    'js__sp-more-text-results': {
      category: '[Category]',
      label: 'Show More Results',
      action: 'Link',
    },
    'js__sp-no-product-topics-help-with-product': {
      category: 'No Product',
      label: 'Product Flow',
      action: 'Alternate Flow Link',
    },
    '_contact-call': {
      category: 'Call',
      action: 'Click',
      label: 'Phone Number',
    },
    '_search-result-link': {
      category: '[Category]',
      action: '[Search Result Link]',
      label: '[Search Result Link Label]',
    },
    'js__back-button-event': {
      category: 'Consumer-Search',
      action: 'Link',
      label: 'Back',
    },
    '_video-result-link': {
      category: '[Category]',
      action: 'Video',
      label: '[Video Title]',
    },
    '_topic-link': {
      category: 'Consumer-Search',
      action: 'Topic',
      label: '[Topic Text]',
    },
    '_social-link': {
      category: 'Support Landing',
      action: '[link]',
      label: 'Social Link',
    },
    '_product-link': {
      category: 'Support Search Result',
      action: '[Product Link Text]',
      label: 'Product Link',
    },
    'sp__product__change-product-button': {
      category: '[Category]',
      action: 'Link',
      label: 'Change Product',
    },
    'product-identification-success-landing': {
      category: 'Support Landing',
      action: 'Product Identified',
      label: '[Product Name]',
    },
    'product-identification-success-contact': {
      category: 'Support Transition - Contact Us',
      action: 'Product Identified',
      label: '[Product Name]',
    },
    'product-identification-success-manuals': {
      category: 'Support Transition - Manuals',
      action: 'Product Identified',
      label: '[Product Name]',
    },
    'product-identification-success-software': {
      category: 'Support Transition - Software',
      action: 'Product Identified',
      label: '[Product Name]',
    },
    'product-identification-success-videos': {
      category: 'Support Transition - Videos',
      action: 'Product Identified',
      label: '[Product Name]',
    },
    'product-identification-success-faq': {
      category: 'Support FAQ',
      action: 'Product Identified',
      label: '[Product Name]',
    },
    '_remove-product-search-landing': {
      category: 'Support Landing',
      action: 'Product Selector - Multiple Match - Link',
      label: 'Back',
    },
    '_remove-product-search-transition': {
      category: 'Support Transition',
      action: 'Product Selector - Multiple Match - Link',
      label: 'Back',
    },
    '_remove-product-search-faq': {
      category: 'Support FAQ',
      action: 'Product Selector - Multiple Match - Link',
      label: 'Back',
    },
    '_chat-possible-product': {
      category: 'Chat',
      action: 'Possible',
      label: '[PRODUCT NAME]',
    },
    '_chat-offered-product': {
      category: 'Chat',
      action: 'Offered',
      label: '[PRODUCT NAME]',
    },
    '_contact-call-tab': {
      category: 'Support Contact',
      action: 'Call Support',
      label: 'Click',
    },
    '_contact-chat-tab': {
      category: 'Support Contact',
      action: 'Chat',
      label: 'Click',
    },
    '_contact-email-tab': {
      category: 'Support Contact',
      action: 'Email',
      label: 'Click',
    },
    '_email-form-valid-submit': {
      category: 'Email',
      action: 'Send - form valid',
      label: 'Submit',
    },
    '_email-form-invalid-submit': {
      category: 'Email',
      action: 'Send - form invalid',
      label: 'Submit',
    },
    '_search-query-form-submit': {
      category: 'Consumer-Search',
      action: 'Search',
      label: '[Query]',
    },
    '_results-info-enable-alt-locale': {
      category: 'Search',
      action: 'Click',
      label: 'Search for results in alternate locale',
    },
    '_alt-locale-search-query-submit': {
      category: 'Search',
      action: 'Search for results in alternate locale',
      label: '',
    },
    '_alt-locale-search-switch-back': {
      category: 'Search',
      action: 'Click',
      label: 'Switch search back to original locale',
    },
    '_invalid-product-search': {
      category: 'Support Landing',
      action: 'Product Identification Unsuccessful',
      label: 'BLANK',
    },
    '_chat-cta': {
      category: 'Support Center',
      action: 'Chat',
      label: 'Email to Chat',
    },
    'js__sp__search__product-error-zero-results': {
      category: 'Product Identification',
      action: 'Help Link',
      label: 'Zero Results',
    },
    'js__sp__search__product-error-specificity': {
      category: 'Product Identification',
      action: 'Help Link',
      label: 'Specificity',
    },
    'js__sp__search__custom-error-link': {
      category: 'Product Identification',
      action: 'Help Link',
      label: 'Custom Error - [Product Search Value]',
    },
    '_remove-product-search': {
      category: 'Specific Product Selector',
      action: 'Back Link',
      label: 'Back to Support Landing',
    },
    '_select-product-from-product-selector': {
      category: 'Specific Product Selector',
      action: 'Select Product',
      label: 'Product Name',
    },
    '_display-possible-product-matches': {
      category: 'Product Identification',
      action: 'Display Possible Product Matches',
      label: '[Product Search Value]',
    },
    '_product-id-display-custom-error-message': {
      category: 'Product Identification',
      action: 'Display Custom Error Message',
      label: '[Product Search Value]',
    },
    '_product-id-display-zero-results-error-message': {
      category: 'Product Identification',
      action: 'Display Zero Results Error Message',
      label: '[Product Search Value]',
    },
    '_product-id-display-too-many-results-error-message': {
      category: 'Product Identification',
      action: 'Display Specificity Error Message',
      label: '[Product Search Value]',
    },
    '_product-id-display-generic-error-message': {
      category: 'Product Identification',
      action: 'Display Generic Error Message',
      label: '[Product Search Value]',
    },
    '_product-identified-intended-product': {
      category: 'Support Landing',
      action: 'Product Identified - Intended Product',
      label: '[Product Search Value]',
    },
    '_results-sidebar-tab-click': {
      category: '[Category]',
      action: 'Tab Click',
      label: '[Tab]',
    },
    '_no-software-content-available': {
      category: 'Support Center Search Result',
      action: 'FAQ Not Found',
      label: 'Product',
    },
    '_welcome-tab-initialized': {
      category: 'Product - Welcome',
      page_type: 'Product - Welcome',
      action: 'Welcome Link',
      link_type: 'Welcome Link',
      label: 'Load',
    },
    '_international-manuals-cta': {
      category: 'Consumer-Manuals',
      action: 'Link',
      label: 'View publications in all languages',
    },
    '_manuals-link-click': {
      category: 'Consumer-Manuals',
      action: 'Link',
      label: '[url]',
    },
    '_authentication-successful': {
      category: 'User Authentication',
      action: 'Authenticate',
      label: 'Pass',
    },
    'faq-view': {
      category: 'Consumer-Search',
      action: 'FAQ',
      label: '[FAQ Title]',
    },
    '_return-for-credit-landing': {
      category: 'CR Landing',
      action: 'Link',
      label: '[Label]',
    },
    '_return-for-credit-select-product-for-return': {
      category: 'Product to Return',
      action: 'Submit',
      label: '[Label]',
      value: '[Value]',
    },
    '_order-management-tab-landing-selected-country': {
      category: 'OM Landing',
      action: 'Country Identified',
      label: '[Country]',
    },
    '_order-management-tab-landing-selected-order-type': {
      category: 'OM Landing',
      action: 'Link',
      label: '[OrderType]',
    },
    '_order-management-tab-landing-selected-product': {
      category: '[Category]',
      action: '[Action]',
      label: '[ProductNameOrSerialNumber]',
    },
    '_add-to-order-partnumber': {
      category: '[Category]',
      action: 'Product Selection - ID',
      label: '[PartNumber]',
    },
    '_add-to-order-product-name': {
      category: '[Category]',
      action: 'Product Selection - Name',
      label: '[PartNumber]',
    },
    '_add-discount-to-order': {
      category: '[Category]',
      action: 'Discount',
      label: '[DiscountPercentage]',
    },
    '_warranty-change-link': {
      category: 'Consumer - OM',
      action: 'Link',
      label: 'Change Warranty',
    },
    '_selected-shipping-method': {
      category: '[Category]',
      action: 'Shipping',
      label: '[ShipOption]',
    },
    '_order-completed': {
      category: '[Category]',
      action: 'Completion Method',
      label: '[CompletionMethod]',
    },
    '_select-product-from-list': {
      category: '[Category]',
      action: '[Action]',
      label: '[ProductName]',
    },
    '_new-order': {
      category: 'Order Tab',
      action: 'Tab',
      label: 'New Order',
    },
    '_logged-in-or-not-after-otc-tab-click': {
      category: 'Aviation OTC',
      action: '[LoggedInOrNot]',
      label: '[ProductName]',
    },
  },
};
